import * as React from 'react'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import STYLES from './AmbassadorPopup.module.sass'

import { Button } from '../../elements/atoms/Button'
import Modal from '../../elements/atoms/Modal/Modal'
import Text from '../../elements/atoms/Text/Text'

const AmbassadorPopup = (): JSX.Element => {
  const shownModal = sessionStorage.getItem('shownModal')
  const [showModal, setShowModal] = useState(!shownModal)

  const { t } = useTranslation('ambassadors')
  const copyContext = 'dashboard.nutrition_school'

  const handleButtonClick = useCallback(() => {
    window.open(
      'https://ambassadoracademy.teachable.com',
      '_blank',
      'noopener,noreferrer'
    )
  }, [])

  const handleModalClose = useCallback(() => {
    sessionStorage.setItem('shownModal', 'true')
    setShowModal(false)
  }, [])

  return (
    <Modal
      fadeAnimation
      isModalOpen={showModal}
      setOpenModal={handleModalClose}
      width={600}
      padding={false}
      bodyScroll={false}
    >
      <div className={STYLES.content}>
        <div className={STYLES.title}>
          <img
            className={STYLES.academyImage}
            alt="Ambassador Academy Crest"
            src={
              'https://butternutbox.com/asset_management/assets/ambassador-academy-2025/en'
            }
          />
          <Text
            text={t(`${copyContext}.title`)}
            variant="display20"
            align="center"
            margin={false}
          />
        </div>
        <Text text={t(`${copyContext}.modal_body`)} align="center" />
        <div className={STYLES.buttonWrapper}>
          <Button
            typography={{
              text: t(`${copyContext}.modal_button`)
            }}
            onClick={handleButtonClick}
            disableAnalytics
          />
        </div>
      </div>
    </Modal>
  )
}

export default AmbassadorPopup
